import { IGeneralState } from '../redux/reducers/generalReducer';
import { Link, UserDto } from '../services/Client';

export default class UserSettingsDaemon {
  /** Current state to use the user settings from. */
  private state: IGeneralState | undefined;

  /**
   * @param interval the daemon time interval in milliseconds
   */
  constructor() {
    this.state = undefined;
  }

  public save = (): void => {
    const state = this.state;
    if (!state || !state.baseLinks) {
      return;
    }

    const user = state.userInfo;
    if (!user) {
      console.warn('Trying to run UserSettingsDaemon without user information');
      return;
    }

    const request = state.client.PATCH_userSettings(state.baseLinks);
    if (!request.canExecute()) {
      console.warn(
        `User ${user.cn} is not allowed to change its user settings`
      );
      return;
    }

    user.userSettings = JSON.stringify(state.userSettings);
    request
      .execute(user)
      .then((value: Link) => {
        if (state.baseLinks) {
          // fetch the updated user info again to have the updated UserDto
          const userInfoRequest = state.client.GET_currentUserInfo(
            state.baseLinks
          );
          if (userInfoRequest.canExecute()) {
            state.client
              .GET_currentUserInfo(state.baseLinks)
              .execute()
              .then((userDto: UserDto) => {
                // update the user info in the redux state
                if (this.state && this.state.userInfo) {
                  this.state.userInfo = userDto;
                }
              })
              .catch((reason: any) => {
                console.error(
                  `Failed to reload updated user settings for ${user.cn}: ${reason}`
                );
              });
          }
        }
      })
      .catch((reason: any) => {
        console.error(
          `Failed to store user settings for ${user.cn}: ${reason}`
        );
      });
  }

  public install = (state: IGeneralState): void => {
    this.state = state;
  }

  public uninstall = (oldState: IGeneralState): void => {
    this.state = undefined;
  }

  public updateState = (state: IGeneralState): void => {
    this.state = state;
  }
}



// WEBPACK FOOTER //
// ./src/services/UserSettingsDaemon.ts